import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { LoanCard } from './card-lenses';

const Accepted = ({ model, onChange, ...cardProps }) => (
  <Card title="Do you have an accepted offer on a new home?" {...cardProps}>
    <BooleanRadioButtons
      name="acceptedOffer"
      value={model.get('acceptedOffer')}
      onChange={onChange.bind(null, 'acceptedOffer')}
    />
  </Card>
);

Accepted.completed = ({ model }) => model.get('acceptedOffer') != null;

Accepted.id = 'AcceptedOffer';

export default LoanCard(Accepted);



// WEBPACK FOOTER //
// ./src/cards/accepted-offer.js